import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Application from './Components/admin/StateContext/AdminContext'
import UserState from './Components/Users/UserContext/UserState';
import { LanguageProvider } from './lang/langcontext/LanguageContext';
import SessionTimeout from './Components/sessionTimeout';
import ErrorHandler from './Components/ErrorHandling/ErrorHandler';
import initializeFetchInterceptor from './Components/ErrorHandling/fetchInterceptor';

const root = ReactDOM.createRoot(document.getElementById('root'));
initializeFetchInterceptor();
root.render(
  <LanguageProvider >
    <Application>
      <UserState>
        <SessionTimeout />
<ErrorHandler>
        <React.StrictMode>
          <App />
        </React.StrictMode>
</ErrorHandler>
      </UserState>
    </Application>
  </LanguageProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
